module.exports = "https://static.wmbcdn.com/uniweb/images/702ba4eb7281a9c49e57ac93a77535d4.svg";